import { API_URL } from "utils/api";

export const calculatePension = async (values) => {

  const payload = {
    "accumulatedCapital": values.accumulatedCapital,
    "age": values.age,
    "pensionAge": values.pensionAge,
    "gender": values.gender,
    "partTime": values.partTime / 100,
    "salary": {
      "base": parseInt(values.salary),
      "indexation": 0.004
    }
  };

  const response = await fetch(API_URL + "/urm/investmentplan", {
    method: "POST",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  return response.json();
};
